// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccount  {
    _originalTypeClassName = "Loom.BO.BankAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccount.translate = translateService;
}
this.Bank = new Domain.Bank();
this.Id = null;
this.AccountName = null;
this.IBAN = null;
this.SwiftCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AccountName:any;
IBAN:any;
SwiftCode:any;
Bank:any;
InvoicingEntity:any;
Employee:any;
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
}
}
static setInvoicingEntity = ($this, value) => {
var oldValue = $this.InvoicingEntity;
$this.InvoicingEntity = value;
if (value != null) {
if (oldValue != null && oldValue.BankAccount != null) { oldValue.BankAccount = null; }
if ($this.InvoicingEntity.BankAccount !== $this) {
Domain.InvoicingEntity.setBankAccount(value, $this);
}
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeBankAccounts(oldValue, $this);
}
Domain.Person.addBankAccounts(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}